import * as R from "ramda"

export const getDateRange = (start, end) => {
  const diff = end.diff(start, "days")

  return R.range(0, diff + 1).map(x => start.add(x, "days"))
}
